export default "__VITE_ASSET__vFKJqmRa__"